import {observer} from "mobx-react";
import {ModalDialog} from "./ModalDialog";
import {DialogStoreInterface} from "../../store";
import {ReactNode} from "react";

interface ConfirmModalDialogProps {
    label?: string
    title?: string
    message?: ReactNode
    store: DialogStoreInterface,
    execute: () => Promise<any>
}

const ConfirmModalDialog = observer(function ConfirmModalDialog({
    label,
    title,
    message,
    store,
    execute
                                                              }: ConfirmModalDialogProps) {
    return <ModalDialog
        store={store}
        actions={[
            {
                label: "Abbrechen",
                execute: async function () {
                    store.dialogOpen = false
                },
                className: 'is-primary is-rounded is-small'
            },
            {
                label: label || "Ausführen",
                execute: async function () {
                    store.dialogOpen = false
                    await execute()
                },
                className: 'is-rounded is-small is-danger'
            }
        ]}
        title={title || "Bestätigung"}
    >
        {message || 'Sind Sie sich sicher, dass Sie die Aktion ausführen wollen?'}
    </ModalDialog>
})

export {
    ConfirmModalDialog
}
